import { isPositiveInteger } from "../utils";

/**
 * @dev Possible value sources for calculations
 * 
 *      Represented by uint8 in Solidity
 * 
 * @param Requests (0x00) data comes from a contract call
 * @param Calculations (0x01) data comes from previous calculations
 */
export enum EDataSource {
    Requests = 0x00,
    Calculations = 0x01
}
/**
* @dev Available SafeMath operations
* 0x00 `add` - addition
* 0x01 `div` - division
* 0x02 `eq`  - a == b
* 0x03 `gt`  - a > b
* 0x04 `lt`  - a < b
* 0x05 `max` - maximum out of 2 int256
* 0x06 `min` - minimum out of 2 int256
* 0x07 `mul` - multiplication
* 0x08 `neq` - a != b
* 0x09 `sub` - subtraction
*/
export enum ESupportedOperations {
    add = 0x00,
    div = 0x01,
    eq = 0x02,
    gt = 0x03,
    lt = 0x04,
    max = 0x05,
    min = 0x06,
    mul = 0x07,
    neq = 0x08,
    sub = 0x09
}

/**
 * @dev Computation step parameters type
 * @param itemOne  Index of the first parameter (positive integer)
 * @param itemTwo Index of the second parameter (positive integer)
 * @param operation a supported command ∈ {0,1,2,3,4,5,6,7,8,9}
 * @param sourseOne value origin 1 ∈ {CONTRACT_CALLS, PREV_CALCULATIONS}
 * @param sourseTwo value origin 2 ∈ {CONTRACT_CALLS, PREV_CALCULATIONS}
 */
export type TComputeStepParams = {
    itemOne: number,
    itemTwo: number,
    operation: ESupportedOperations,
    sourseOne: EDataSource,
    sourseTwo: EDataSource,
}

/**
 * @dev Securely populates the calculation step params
 */
// export class TOperation {

//     private emptyOperation: TComputeStepParams = {
//         itemOne: 0,
//         itemTwo: 1,
//         operation: ESupportedOperations.add,
//         sourseOne: EDataSource.Requests,
//         sourseTwo: EDataSource.Requests,
//     };

//     private erroPrefix: string = "TOperation Error:";

//     private params: TComputeStepParams = this.emptyOperation;

//     // ================== GETTERS ==================

//     getEmptyOperation(): TComputeStepParams {
//         return this.emptyOperation;
//     }

//     getOperation(): TComputeStepParams {
//         return this.params;
//     }

//     // ================== SETTERS ==================

//     setAll(data: TComputeStepParams): TOperation {
//         this._validatePositionIndex(data.itemOne);
//         this._validatePositionIndex(data.itemTwo);
//         this.params = data;
//         return this;
//     }

//     setFirstParamPos(pos: number): TOperation {
//         this._validatePositionIndex(pos);
//         this.params.itemOne = pos;
//         return this;
//     }

//     setFirstSource(sorce: EDataSource): TOperation {
//         this.params.sourseOne = sorce;
//         return this;
//     }

//     setOperation(op: ESupportedOperations): TOperation {
//         this.params.operation = op;
//         return this;
//     }

//     setSecondParamPos(pos: number): TOperation {
//         this._validatePositionIndex(pos);
//         this.params.itemTwo = pos;
//         return this;
//     }

//     setSecondSource(sorce: EDataSource): TOperation {
//         this.params.sourseTwo = sorce;
//         return this;
//     }

//     private _validatePositionIndex(index: number) {
//         if (!isPositiveInteger(index)) {
//             throw new Error(
//                 `${this.erroPrefix} Index ${index} must be a positive integer number.`
//             );
//         }
//     }

// }